import { EngineError } from './types.js';

export function checkInt(name: string, v: unknown, min: number, max: number): number {
  if (typeof v !== 'number' || !Number.isInteger(v) || v < min || v > max) {
    throw new EngineError('INVALID_CONFIG', `${name} must be an integer in [${min}, ${max}]`);
  }
  return v;
}

export function checkBool(name: string, v: unknown): boolean {
  if (typeof v !== 'boolean') throw new EngineError('INVALID_CONFIG', `${name} must be a boolean`);
  return v;
}

export function checkEnum<T extends string>(name: string, v: unknown, values: readonly T[]): T {
  if (typeof v !== 'string' || !values.includes(v as T)) {
    throw new EngineError('INVALID_CONFIG', `${name} must be one of ${values.join(', ')}`);
  }
  return v as T;
}

/** Shallow merge that ignores keys not present in defaults (prevents config pollution). */
export function mergeKnown<T extends object>(defaults: T, input?: Partial<T>): T {
  const out = { ...defaults };
  if (!input) return out;
  for (const key of Object.keys(defaults) as (keyof T)[]) {
    if (input[key] !== undefined) out[key] = input[key] as T[keyof T];
  }
  return out;
}

export function deepClone<T>(v: T): T {
  return structuredClone(v);
}
